const config = {
  pageSizes: [10, 20, 50, 100],
  currentPage: 1,
  pageSize: 10
}

export { config }
